
import { useState, useEffect } from 'react';
import { HappyHourSchedule } from '@/types/menu';

export const useHappyHour = (schedule: HappyHourSchedule | undefined) => {
  const [isHappyHour, setIsHappyHour] = useState(false);

  useEffect(() => {
    if (!schedule?.enabled) {
      setIsHappyHour(false);
      return;
    }

    const checkHappyHour = () => {
      const now = new Date();
      const currentDay = now.getDay();

      if (!schedule.days.includes(currentDay)) {
        setIsHappyHour(false);
        return;
      }

      const [startHour, startMinute] = schedule.startTime.split(':').map(Number);
      const [endHour, endMinute] = schedule.endTime.split(':').map(Number);

      const startTime = new Date(now);
      startTime.setHours(startHour, startMinute, 0, 0);

      const endTime = new Date(now);
      endTime.setHours(endHour, endMinute, 0, 0);

      setIsHappyHour(now >= startTime && now <= endTime);
    };

    checkHappyHour();
    const interval = setInterval(checkHappyHour, 60000);

    return () => clearInterval(interval);
  }, [schedule]);

  return { isHappyHour, setIsHappyHour };
};
